import { render, staticRenderFns } from "./WorkshopGroupUserModal.vue?vue&type=template&id=549247b2&"
import script from "./WorkshopGroupUserModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports